<template>
  <div>
    <Legenda titulo="Release Notes" legenda="Novidades do sistema">
      <v-btn icon @click="dialog_ativo = true">
        <v-icon :size="21">mdi-gift</v-icon>
      </v-btn>
    </Legenda>

    <SysDialogFullScreen v-model="dialog_ativo" titulo="Release Notes" ocultar-acoes>
      <div style="height: calc(100vh - 67px) ">
        <iframe
          v-if="dialog_ativo"
          src="https://share-docs.clickup.com/31047243/d/h/xkfjb-11363/28acfdbcc369b8f"
          width="100%"
          height="100%"
          style="border: 0"
        ></iframe>
      </div>
    </SysDialogFullScreen>
  </div>
</template>

<script>
import SysDialogFullScreen from '../padraoDeLayout/SysDialogFullScreen.vue'
import Legenda from "./../produto/detalhes/Legenda.vue"

export default {
  components: {
    SysDialogFullScreen,
    Legenda
  },
  data: () => ({
    dialog_ativo: false
  })
}
</script>

<style scoped>

</style>
